import React, { useState, useEffect } from 'react';
import { api } from '../App';

function Requests() {
  const [requests, setRequests] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const limit = 15;

  const loadRequests = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ page, limit });
      if (statusFilter) params.append('status', statusFilter);
      const data = await api(`/admin/requests?${params}`);
      setRequests(data.requests);
      setTotal(data.total);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadRequests(); }, [page, statusFilter]);

  const totalPages = Math.ceil(total / limit);

  const getStatusBadge = (status) => {
    const classes = {
      pending: 'badge-pending',
      active: 'badge-active',
      matched: 'badge-active',
      confirmed: 'badge-active',
      in_progress: 'badge-pending',
      completed: 'badge-completed',
      cancelled: 'badge-suspended',
    };
    return classes[status] || '';
  };

  return (
    <div>
      <h1 style={{ marginBottom: 20 }}>Requests</h1>
      
      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 12 }}>
          <select 
            value={statusFilter} 
            onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }} 
            style={{ width: 200 }}
          >
            <option value="">All Statuses</option>
            <option value="pending">Pending</option>
            <option value="active">Active</option>
            <option value="matched">Matched</option>
            <option value="confirmed">Confirmed</option>
            <option value="in_progress">In Progress</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>
        ) : (
          <>
            <table>
              <thead>
                <tr>
                  <th>Request ID</th>
                  <th>Owner</th>
                  <th>Port</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Helpers</th>
                </tr>
              </thead>
              <tbody>
                {requests.map(req => (
                  <tr key={req.id}>
                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>
                      {req.id.slice(0, 8)}...
                    </td>
                    <td>
                      <div>{req.owner_first_name} {req.owner_last_name}</div>
                      <div style={{ fontSize: 12, color: '#666' }}>{req.owner_email}</div>
                    </td>
                    <td>
                      <div>{req.port_name}</div>
                      <div style={{ fontSize: 12, color: '#666' }}>{req.port_country}</div>
                    </td>
                    <td>
                      {req.scheduled_date ? (
                        <>
                          <div>{new Date(req.scheduled_date).toLocaleDateString()}</div>
                          <div style={{ fontSize: 12, color: '#666' }}>{req.scheduled_time}</div>
                        </>
                      ) : (
                        <span style={{ color: '#666' }}>ASAP</span>
                      )}
                    </td>
                    <td>
                      <span className={`badge ${getStatusBadge(req.status)}`}>
                        {req.status}
                      </span>
                      {req.is_urgent === 1 && (
                        <span className="badge badge-suspended" style={{ marginLeft: 4 }}>
                          URGENT
                        </span>
                      )}
                    </td>
                    <td>{req.helpers_confirmed || 0} / {req.helpers_needed}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20 }}>
              <span style={{ color: '#666', fontSize: 14 }}>
                Showing {requests.length} of {total} requests
              </span>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn" disabled={page === 1} onClick={() => setPage(p => p - 1)} style={{ background: '#eee' }}>
                  Previous
                </button>
                <span style={{ padding: '10px 16px' }}>Page {page} of {totalPages}</span>
                <button className="btn" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)} style={{ background: '#eee' }}>
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Requests;
